import React from "react";

const SKELETON_ROWS = 3;

const MemberBreakdownSkeleton = () => (
  <div className="widgetCardMemberBreakdown">
    {Array.from({ length: SKELETON_ROWS }).map((_, i) => (
      <div key={i} className="widgetCardMemberBreakdownRow">
        <div className="widgetCardMemberBreakdownHeader">
          <span className="linear-background widgetBreakdownSkeletonName" />
          <span className="linear-background widgetBreakdownSkeletonValue" />
        </div>
        <div className="widgetCardMemberBreakdownBarTrack">
          <span className="linear-background widgetBreakdownSkeletonBar" />
        </div>
      </div>
    ))}
  </div>
);

export default MemberBreakdownSkeleton;
